<template>
  <div class="contractor_re_registered contain">
    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupCheck v-if="popup == 'check'" :text="successText" @go="popupAction" @cancel="poupupEnter">
          <textarea class="input_primary" v-model="reason"></textarea>
        </PopupCheck>

        <PopupSuccess v-if="popup == 'success'" :text="successText" @check="poupupEnter"></PopupSuccess>
        <PopupError v-if="popup == 'error'" :text="successText" @check="poupupEnter"></PopupError>
      </Popup>
    </MyTransition>
    <div class="form_input flex" v-for="(field, index) in formField" :key="index">
      <label>
        {{ field.name }}
        <span class="must" v-if="field.must">*</span>
      </label>
      <!--select-->
      <div class="el_elment" v-if="field.type == 'select'">
        <template v-if="field.val == 'department'">
          <el-select v-model="formInput[field.val]" :placeholder="field.placeholder">
            <el-option v-for="item in options.department" :key="item.departmentno" :label="item.departmentname"
              :value="item.departmentno"></el-option>
          </el-select>
        </template>
        <template v-else>
          <el-select v-model="formInput[field.val]" :placeholder="field.placeholder">
            <el-option v-for="item in options[field.val]" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </template>
      </div>
      <!--switch-->
      <div v-else-if="field.type == 'switch'">
        <el-switch v-model="formInput[field.val]" :active-text="field.switchText[0]"
          :inactive-text="field.switchText[1]"></el-switch>
      </div>
      <!--date-->
      <div class="el_elment" v-else-if="field.type == 'date'">
        <el-date-picker v-model="formInput[field.val]" type="date" :placeholder="field.placeholder"
          value-format="yyyy-MM-dd" popper-class="picker-date"></el-date-picker>
      </div>
      <div v-else-if="field.type == 'input'">
        <input type="text" class="input_primary" v-model.lazy="formInput[field.val]" />
      </div>
      <!--textarea-->
      <div v-else-if="field.type == 'textarea'">
        <textarea class="input_primary" v-model="formInput[field.val]" />
      </div>
      <!---額外狀態-->
      <div v-else>
        <!--判斷布林值-->
        <template v-if="formInput[field.val] === true">
          <i class="el-icon-success"></i>
        </template>
        <template v-else-if="formInput[field.val] === false">
          <i class="el-icon-error"></i>
        </template>
        <template v-else>{{ formInput[field.val] }}</template>
      </div>
    </div>

    <div class="form_dow" v-if="this.$store.state.user.role == 'vendor'">
      <div class="title">下載文件區域</div>
      <div class="dow_btn flex">
        <template v-for="(item, index) in dowFile">
          <a :key="index" target="_blank" :href="`${storage}${item.file_path}?${time}`">
            <button type="button" class="btn_primary">
              {{ item.file_name }}
            </button>
          </a>
        </template>

        <!-- <button type="button" class="btn_primary">承攬商安全衛生環保管理辦法</button>
        <button type="button" class="btn_primary">承攬商資安管制聲明書</button>-->
      </div>
    </div>
    <!-- this.$store.state.user.isPass == 0 因應新版文件更新, 先把卡控條件拿掉-->
    <div class="form_upload" v-if="this.$store.state.user.role == 'vendor'">
      <div class="title">上傳文件 <span class="upload_reminder">(文件 "上傳" 後，請記得 點擊"送出資料"，已儲存文件)</span></div>
      <div class="upload_btn">
        <div>
          <label for="registration" :class="{ hasFile: file['business_file'] }">
            <template v-if="!file.business_file">營業登記資料</template>
            <template v-else>
              營業登記資料: {{ file.business_file }}
              <span class="cancel_file" @click.prevent="cancelFile('business_file')">
                <i class="el-icon-error"></i>
              </span>
            </template>
          </label>
          <input id="registration" type="file" @change="registration" />
          <div class="list"></div>
        </div>
        <div v-if="formInput.factory_address && formInput.factory_address !== '無'">
          <label for="registration_mark" :class="{ hasFile: file['factory_file'] }">
            <template v-if="!file.factory_file">工廠登記證</template>
            <template v-else>
              工廠登記證: {{ file.factory_file }}
              <span class="cancel_file" @click.prevent="cancelFile('factory_file')">
                <i class="el-icon-error"></i>
              </span>
            </template>
          </label>
          <input id="registration_mark" type="file" @change="registrationMark" />
          <div class="list"></div>
        </div>
        <div>
          <label for="environment" :class="{ hasFile: file['information_file'] }">
            <template v-if="!file.information_file">承攬商安全衛生環保承諾書</template>
            <template v-else>
              承攬商安全衛生環保承諾書: {{ file.information_file }}
              <span class="cancel_file" @click.prevent="cancelFile('information_file')">
                <i class="el-icon-error"></i>
              </span>
            </template>
          </label>
          <input id="environment" type="file" @change="environment" />
          <div class="list"></div>
        </div>
        <div>
          <label for="security" :class="{ hasFile: file['safe_file'] }">
            <template v-if="!file.safe_file">承攬商資安管制聲明書</template>
            <template v-else>
              承攬商資安管制聲明書: {{ file.safe_file }}
              <span class="cancel_file" @click.prevent="cancelFile('safe_file')">
                <i class="el-icon-error"></i>
              </span>

            </template>
          </label>
          <input id="security" type="file" @change="security" />
          <div class="list"></div>
        </div>
      </div>
    </div>
    <div class="form_dow" v-if="this.$store.state.user.role !== 'vendor'">
      <div class="title">下載承攬商上傳文件</div>
      <div class="dow_btn flex">
        <a :href="`${storage}${formInput.business_file}?${time}`" target="_blank">
          <button type="button" :class="formInput.business_file ? 'btn_primary' : 'btn_gray'">
            營業登記資料
            <span v-if="!formInput.business_file">-沒有資料</span>
          </button>
        </a>
        <a :href="`${storage}${formInput.factory_file}?${time}`" target="_blank">
          <button type="button" :class="formInput.factory_file ? 'btn_primary' : 'btn_gray'">
            工廠登記證
            <span v-if="!formInput.factory_file">-沒有資料</span>
          </button>
        </a>
        <a :href="`${storage}${formInput.information_file}?${time}`" target="_blank">
          <button type="button" :class="formInput.information_file ? 'btn_primary' : 'btn_gray'">
            承攬商安全衛生環保承諾書
            <span v-if="!formInput.information_file">-沒有資料</span>
          </button>
        </a>
        <!-- <a :href="`${storage}${formInput.safe_file}?${time}`" target="_blank">
          <button type="button" :class="formInput.safe_file ? 'btn_primary' : 'btn_gray'">
            承攬商資安管制聲明書
            <span v-if="!formInput.safe_file">-沒有資料</span>
          </button>
        </a> -->
        <a :href="`${storage}${formInput.safe_file}?${time}`" target="_blank">
          <button type="button" :class="formInput.safe_file ? 'btn_primary' : 'btn_gray'">
            承攬商資安管制聲明書
            <span v-if="!formInput.safe_file">-沒有資料</span>
          </button>
        </a>
        <a v-if="false" :href="`${storage}${formInput.new_safe_file}?${time}`" target="_blank"
          @click="pp(`${storage}${formInput.safe_file}?${time}`)">
          <button type="button" :class="formInput.new_safe_file ? 'btn_primary' : 'btn_gray'">
            承攬商資安管制聲明書 2021-03
            <span v-if="!formInput.new_safe_file">-沒有資料</span>
          </button>
        </a>
      </div>
    </div>
    <!-----臨時區域，上傳新的資訊簽名單====>現在已經不需要了 2/18刪除----->
    <Div class="form_dow"
      v-if="false && this.$store.state.user.role !== 'manager' && this.$store.state.user.isPass !== 0">
      <!-- <div class="title">下載新上傳文件</div>
      <div class="dow_btn flex" v-for="(list,index) in dowFile" :key="index">
        <template v-if="list.file_path.includes('資安管制')">
          <a
            :href="`${storage}${list.file_path}?${time}`"
            target="_blank"
          >
            <button
              type="button"
              class="btn_primary"
            >
              承攬商資安管制聲明書
            </button>
          </a>
        </template>

      </div>
      <div class="form_upload">
        <div class="upload_btn">
          <label for="new_security">
            <template v-if="!newFile.new_safe_file">上傳 承攬商資安管制聲明書 2021-03</template>
            <template v-else>
              {{ newFile.new_safe_file }}
              <span
                class="cancel_file"
                @click.prevent="cancelNewFile('safe_file')"
              >
                <i class="el-icon-error"></i>
              </span>
            </template>
          </label>
          <input class="display_input" id="new_security" type="file" @change="newSecurity" />
          <div class="list"></div>
        </div>
      </div>
      <div class="action_btn">
        <button class="btn_light" @click="newPaperUpload">資料上傳</button>
      </div> -->
    </Div>

    <div class="register_btn">
      <template v-if="this.$store.state.user.role == 'manager' &&
      this.$store.state.user.isPass == 2
      ">
        <div class="action_btn flex">
          <button class="btn_save" @click="CodeEnter">審核通過</button>
          <button class="btn_error" @click="cancel">審核不通過</button>
        </div>
      </template>
      <!-- this.$store.state.user.isPass == 0 因應新版文件更新, 先把卡控條件拿掉-->

      <template v-else-if="this.$store.state.user.role !== 'manager'">
        <button class="btn_light" @click="enter">資料送出</button>
        <!-- <button class="btn_gray" @click="save">存為草稿</button> -->
      </template>
      <button class="btn_gray" @click="returnLogin" v-if="this.$store.state.user.isPass == 2">
        返回
      </button>
    </div>
  </div>
</template>

<style lang="scss">
.display_input {
  display: none;
}

.el-date-picker__header {
  display: flex;
  align-items: center;
}

.contractor_re_registered {
  text-align: left;
  background: #fff;
  border-radius: 10px;
  padding: 30px 20px;
  box-shadow: 5px 5px 20px -12px rgba($color: #000000, $alpha: 0.5);
  margin-bottom: 30px;

  .form_input {
    flex-wrap: wrap;
    white-space: nowrap;

    label {
      flex: 3;
      font-weight: bold;

      span {
        color: var(--subColor);
      }
    }

    >div {
      flex: 7;

      input,
      textarea {
        width: 100%;
      }
    }
  }
}

.form_input {
  align-items: center;
  font-size: 15px;
  margin: 15px 0;

  .el_elment {
    flex: 7;
    width: 100%;

    .el-select {
      width: 100%;
    }

    .el-date-editor.el-input,
    .el-input {
      width: 100%;

      .el-input__prefix {
        display: none;
      }

      input {
        padding: 8px 10px;
        border-radius: 5px;
        background: #e5e5e5;
        border: 1px solid #e5e5e5;
        box-shadow: 1px 1px 2px -1px rgba(0, 0, 0, 0.2) inset;

        &:hover,
        &:focus {
          background: #fff;
          border: 1px solid #e5e5e5;
          box-shadow: none;
        }

        /*webkit瀏覽器專用*/
        &::-webkit-input-placeholder {
          color: #b6b6b6;
        }

        /*Firefox 4-18瀏覽器專用*/
        &::-moz-placeholder {
          color: #b6b6b6;
        }

        /*IE10瀏覽器專用*/
        &:-ms-input-placeholder {
          color: #b6b6b6;
        }
      }
    }
  }
}

.form_dow {
  margin: 20px 0;
  background: #f0f0f0;
  padding: 20px 10px;
  border-radius: 10px;

  .title {
    font-size: 20px;
    font-weight: bold;
  }

  .dow_btn {
    margin-top: 10px;
    justify-content: space-around;
    flex-wrap: wrap;

    a {
      width: 100%;
    }

    button {
      margin: 3px;
      box-shadow: 10px 10px 20px -10px rgba($color: #000000, $alpha: 0.5);

      &:hover {
        box-shadow: 2px 2px 1px -1px rgba($color: #000000, $alpha: 0.5);
      }
    }
  }

}

.form_upload {
  margin: 20px 0 0 0;

  .title {
    font-size: 20px;
    font-weight: bold;
  }

  .upload_reminder {
    color: var(--red);
    font-size: 14px;
  }

  .upload_btn {
    >div {
      margin: 15px 0;
      width: 100%;

      input {
        display: none;
      }
    }

    label {
      display: block;
      font-size: 14px;
      cursor: pointer;
      padding: 12px 20px;
      width: 100%;
      text-align: center;
      border-radius: 5px;
      color: #737373;
      border: 2px dashed #ccc;

      &:hover {
        border: 2px dashed var(--mainColor);
        color: var(--mainColor);
        font-weight: bold;
      }

      .cancel_file {
        padding: 0 10px;
      }
    }

    .hasFile {
      background: var(--mainColor2);
      color: #fff;
      border: none;

      &:hover {
        border: 2px dashed var(--mainColor);
        color: #fff;
        background: var(--mainColor);
      }
    }
  }
}

.register_btn {
  margin: 30px 0 10px 0;

  >button {
    margin: 10px 0;
  }

  .btn_light {
    box-shadow: 10px 10px 20px -10px rgba($color: #000, $alpha: 0.4);

    &:hover {
      box-shadow: 3px 3px 5px -1px rgba($color: #000, $alpha: 0.4);
    }
  }

  .btn_border {
    border: 1px solid var(--mainColor);
    color: var(--mainColor);
  }

  .action_btn {
    margin-bottom: 10px;

    >button {
      margin: 0 10px;
    }
  }
}

// 隱藏el-date-picker的header中, 年份的前後按鈕
.picker-date {
  .el-date-picker__header {
    button:nth-child(1) {
      display: none;
    }

    button:nth-child(5) {
      display: none;
    }
  }
}
</style>

<script>
import * as moment from "moment";
export default {
  name: "contractorLogin",
  data() {
    return {
      formInput: {
        vendor_chinese: null,
        vendor_english: null,
        license_factory: null,
        tax_id: null,
        is_foreign: false,
        owner: null,
        type: null,
        revenue_year: null,
        listed_code: null,
        company_address: null,
        factory_address: null,
        invoice_address: null,
        capital: null,
        found_date: null,
        contact_person: null,
        phone: null,
        fax: null,
        email: null,
        employee_number: null,
        license_type: null,
        bussiness_item: null,
        customer: null,
        business_file: null,
        factory_file: null,
        information_file: null,
        safe_file: null,
        // new_safe_file: null,
      },
      formData: new FormData(),
      newFormData: new FormData(),
      options: {
        license_factory: ["N6"],
        department: [],
      },
      dowFile: [],
      file: {
        business_file: null, //營業事業登記證
        factory_file: null, //工廠登記證
        information_file: null, //安全衛生環保承諾書
        safe_file: null,//資安管制聲明書
        // new_safe_file: null, //因應2021-03時改版, 臨時的安管制聲明書
      },
      newFile: {
        new_safe_file: "",
      },
      popupStatus: false,
      successText: null,
      popup: null,
      formField: [
        // {
        //   name: "需求單位",
        //   val: "department",
        //   placeholder: "choose",
        //   must: true,
        //   type: "select",
        //   rewrite: true
        // },
        {
          name: "供應商名稱(中)",
          val: "vendor_chinese",
          placeholder: "中文名稱",
          must: true,
          type: "input",
          // rewrite: false
        },
        {
          name: "供應商名稱(英)",
          val: "vendor_english",
          placeholder: "英文名稱",
          must: false,
          type: "input",
          // rewrite: false
        },
        {
          name: "領證廠區",
          val: "license_factory",
          placeholder: "choose",
          must: true,
          type: "select",
          // rewrite: false
        },
        {
          name: "統一編號",
          val: "tax_id",
          placeholder: "登入帳號",
          must: true,
          type: "text",
          // rewrite: false
        },
        {
          name: "外國廠商",
          val: "is_foreign",
          placeholder: null,
          must: true,
          type: "switch",
          switchText: ["是", "否"],
          // rewrite: false
        },
        {
          name: "負責人",
          val: "owner",
          placeholder: null,
          must: true,
          type: "input",
          // rewrite: false
        },
        {
          name: "性質",
          val: "type",
          placeholder: null,
          must: false,
          type: "input",
          // rewrite: false
        },
        {
          name: "年營業額",
          val: "revenue_year",
          placeholder: null,
          must: false,
          type: "input",
          dataType: "number",
          // rewrite: false
        },
        {
          name: "上市櫃代碼",
          val: "listed_code",
          placeholder: null,
          must: false,
          type: "input",
          // rewrite: false
        },
        {
          name: "公司地址",
          val: "company_address",
          placeholder: null,
          must: true,
          type: "input",
          rewrite: false,
        },
        {
          name: "工廠地址",
          val: "factory_address",
          placeholder: null,
          must: false,
          type: "input",
          // rewrite: false
        },
        {
          name: "發票地址",
          val: "invoice_address",
          placeholder: null,
          must: true,
          type: "input",
          // rewrite: false
        },
        {
          name: "登記資本額",
          val: "capital",
          placeholder: null,
          must: true,
          type: "input",
          dataType: "number",
          // rewrite: false
        },
        {
          name: "設立日期",
          val: "found_date",
          placeholder: "年-月-日",
          must: true,
          type: "date",
          // rewrite: false
        },
        {
          name: "業務聯絡人",
          val: "contact_person",
          placeholder: null,
          must: true,
          type: "input",
          // rewrite: false
        },
        {
          name: "電話",
          val: "phone",
          placeholder: null,
          must: true,
          type: "input",
          // rewrite: true
        },
        {
          name: "傳真",
          val: "fax",
          placeholder: null,
          must: true,
          type: "input",
          // rewrite: false
        },
        {
          name: "E-mail",
          val: "email",
          placeholder: null,
          must: true,
          type: "input",
          // rewrite: true
        },
        {
          name: "員工人數",
          val: "employee_number",
          placeholder: null,
          must: true,
          type: "input",
          dataType: "number",
          // rewrite: false
        },
        {
          name: "主要營業項目",
          val: "bussiness_item",
          placeholder: null,
          must: false,
          type: "textarea",
          // rewrite: false
        },
        {
          name: "主要客戶",
          val: "customer",
          placeholder: null,
          must: false,
          type: "textarea",
          // rewrite: true
        },
        {
          name: "證照種類",
          val: "license_type",
          placeholder: null,
          must: false,
          type: "textarea",
          // rewrite: false
        },
      ],
      checkOK: [],
      reason: null,
    };
  },
  computed: {
    vendorId() {
      return this.$route.query.vendorId;
    },
    vendorId_login() {
      return this.$store.state.user.id;
    },
    storage() {
      return this.$http.base.storage;
    },
    time() {
      return moment().format();
    },
  },
  methods: {
    getData() {
      //先判斷身份
      if (
        this.$store.state.user.role == "manager" ||
        this.$store.state.user.role == "department"
      ) {
        //工安只能觀看不能修改
        //承攬商id需要從上一頁點點擊的id拿到
        this.$http.api.vendor.vendorBasisGet(this.vendorId).then((res) => {
          for (let key in this.formInput) {
            this.formField.forEach((el) => {
              el.type = "text";
            });
            this.formInput[key] = res.data[key];
          }

          this.formField.forEach((el) => {
            if (el.dataType == "number") {
              this.formInput[el.val] = parseInt(
                this.formInput[el.val]
              ).toLocaleString();
            }
          });
        });
      } else if (this.$store.state.user.role == "vendor") {
        //承攬商
        //承攬商id必須由登入拿到
        this.$http.api.vendor
          .vendorBasisGet(this.vendorId_login)
          .then((res) => {
            console.log('vendorBasis:', res.data);
            for (let key in this.formInput) {
              //承攬商只要輸入一次，就會鎖住不讓他輸入了
              //判斷承攬商的狀態
              if (this.$store.state.user.isPass !== 0) {
                this.formInput[key] = res.data[key];
                this.formField.forEach((el) => {
                  el.type = "text";
                });
              } else {
                if (key !== "is_foreign") {
                  this.formInput[key] = res.data[key];
                }
              }
              //之前的做法
              //如果已經有輸入的，無法重新復寫的欄位
              // this.formField.forEach(el => {
              //   if (!el.rewrite) {
              //     el.type !== "text" && res.data[el.val]
              //       ? (el.type = "text")
              //       : "";
              //   }
              // });
              // this.formInput[key] = res.data[key];
            }
            for (let key in this.file) {
              this.file[key] = this.formInput[key];
            }
          });
      }
      this.getDowFile();
      this.getOptions();
    },
    getDowFile() {
      this.$http.api.file.registerDow().then((res) => {
        //  this.dowFile=res.data.filter(el=>{
        //   return !el.file_name.includes('教學')
        // })
        this.dowFile = res.data;
      });
    },
    getOptions() {
      fetch("http://192.168.10.31/dcc/api/group", { method: "GET" })
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          res.forEach((el) => {
            el.departments.forEach((e) => {
              this.options.department.push(e);
            });
          });
        });
    },
    registration(e) {
      this.file.business_file = e.target.files[0].name;
      this.formData.append("business_file", e.target.files[0]); //放進上傳的檔案
      e.target.value = '';
    },
    registrationMark(e) {
      this.file.factory_file = e.target.files[0].name;
      this.formData.append("factory_file", e.target.files[0]); //放進上傳的檔案
      e.target.value = '';
    },
    environment(e) {
      this.file.information_file = e.target.files[0].name;
      this.formData.append("information_file", e.target.files[0]); //放進上傳的檔案
      e.target.value = '';
    },
    security(e) {
      this.file.safe_file = e.target.files[0].name;
      this.formData.append("safe_file", e.target.files[0]); //放進上傳的檔案
      e.target.value = '';
    },
    newSecurity(e) {
      this.newFile.new_safe_file = e.target.files[0].name;
      this.newFormData.append("new_safe_file", e.target.files[0]); //放進上傳的檔案
      e.target.value = '';
    },
    cancelFile(file) {
      this.file[file] = null;
      this.formData.delete(file);
      this.formInput[file] = null;
    },
    cancelNewFile(file) {
      this.newFile[file] = null;
      this.newFormData.delete(file);
    },
    returnLogin() {
      this.$router.go(-1);
    },
    newPaperUpload() {
      this.$http.api.vendor
        .vendorNewPaper(this.vendorId_login, this.newFormData, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          this.popupStatus = true;
          this.successText = "送出成功";
          this.popup = "success";
        })
        .catch((error) => {
          this.popupStatus = true;
          this.popup = "error";
          this.successText = "送出失敗";
        });
    },
    enter() {
      this.checkOK = [];
      this.formField.forEach((el) => {
        //挑出必填且欄位沒有值
        if (
          el.must &&
          (this.formInput[el.val] == null || this.formInput[el.val].length == 0)
        ) {
          //去除掉選項是false的項目

          this.checkOK.push(el.name);
        }
      });
      if (this.checkOK.length !== 0) {
        //必填有遺漏
        this.popupStatus = true;
        this.popup = "error";
        this.successText = `請填寫:${this.checkOK.join()}`;
        // 判斷文件
        if (!this.file.idCard && !this.file.labor) {
          this.successText = `請填寫:${this.checkOK.join()}，並上傳必要文件`;
        }
      }

      if (this.checkOK.length == 0) {
        //必填完成
        //===============================
        //轉資料格式
        this.formData.append("form_input", JSON.stringify(this.formInput));

        this.$http.api.vendor
          .vendorBasisPost(this.vendorId_login, this.formData, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          })
          .then((res) => {
            this.popupStatus = true;
            this.successText = "送出成功";
            this.popup = "success";

          })
          .catch((error) => {
            this.popupStatus = true;
            this.popup = "error";
            this.successText = "送出失敗";
          });
      }
    },
    save() {
      //轉資料格式
      this.formData.append("form_input", JSON.stringify(this.formInput));

      this.$http.api.vendor
        .vendorBasisSave(this.vendorId_login, this.formData, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          this.popupStatus = true;
          this.successText = "存檔成功";
          this.popup = "success";
        })
        .catch((error) => {
          this.popupStatus = true;
          this.popup = "error";
          this.successText = "存檔失敗";
        });
    },
    CodeEnter() {
      this.$http.api.admin
        .vendorCheck(this.vendorId)
        .then((res) => {
          this.popupStatus = true;
          this.successText = "審核成功";
          this.popup = "success";
          this.getData();
        })
        .catch((error) => {
          this.popupStatus = true;
          this.popup = "error";
          this.successText = "審核失敗";
        });
    },
    cancel() {
      this.popupStatus = true;
      this.popup = "check";
      this.successText = `
          請填寫審核不通過之原因:<br><br>
          `;
    },
    poupupEnter() {
      this.popupStatus = false;
    },
    popupAction() {
      this.$http.api.admin
        .vendorCancel(this.vendorId, {
          reason: this.reason,
        })
        .then((res) => {
          this.popupStatus = true;
          this.successText = "操作成功";
          this.popup = "success";
          this.getData();
        })
        .catch((error) => {
          this.popupStatus = true;
          this.popup = "error";
          this.successText = "操作失敗";
        });
    },
    pp(t) {

    }
  },
  watch: {
    formInput: {
      handler(newVal, oldVal) {
        //判斷身份監聽
        if (this.$store.state.user.role == "vendor") {
          this.formField.forEach((el) => {
            if (el.dataType == "number") {
              const item = newVal[el.val];
              const rule = /^[0-9]*$/;
              if (item !== null) {
                if (!item.match(rule)) {
                  this.popupStatus = true;
                  this.popup = "error";
                  this.successText = "請輸入純數字";
                }
              }
            }
          });
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
